import { render, staticRenderFns } from "./Marketplace.vue?vue&type=template&id=5aa566a9"
import script from "./Marketplace.vue?vue&type=script&lang=js"
export * from "./Marketplace.vue?vue&type=script&lang=js"
import style0 from "./Marketplace.vue?vue&type=style&index=0&id=5aa566a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports